import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import {
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
  MatLegacySnackBar as MatSnackBar,
} from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'app-message-snackbar',
  templateUrl: './message-snackbar.component.html',
  styleUrls: ['./message-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageSnackbarComponent implements AfterViewInit {
  @ViewChild('dismissButton', { static: true })
  dismissButton: ElementRef<HTMLButtonElement>;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public messageList: string[],
    private snackBar: MatSnackBar,
  ) {}

  public ngAfterViewInit(): void {
    this.dismissButton.nativeElement?.focus();
  }

  public dismiss(): void {
    this.snackBar.dismiss();
  }
}
